import React, { FC, useMemo } from 'react';
import { Form } from '@ant-design/compatible';
import CapExCategoryInput from '../invoices_detail_details_page/CapExCategoryInput';
import { connect } from 'react-redux';
import { getBuyerCompanySettingValue } from '../../utils/AuthUtils';

const CapExCategoryFormField: FC<any> = ({
	isCapex,
	getFieldDecorator,
	formData,

	companyConfig,
	userType,
	currentUser,
}): React.ReactElement => {
	const allowCapExCategory = useMemo(
		() =>
			getBuyerCompanySettingValue(userType)(
				'capExConfig.acceptCapExCategory',
				companyConfig,
				currentUser
			),
		[companyConfig, currentUser, userType]
	);

	return allowCapExCategory && isCapex ? (
		<Form.Item label="CapEx Category">
			{getFieldDecorator('capExCategoryInput', {
				initialValue: {
					capExCategoryId: formData.capExCategoryId,
					capExCategory: formData.capExCategory,
				},
			})(<CapExCategoryInput />)}
		</Form.Item>
	) : null;
};

const mapStateToProps = (state) => ({
	companyConfig: state.company_config.detail,
	currentUser: state.session.currentUser,
});

const ComponentWithoutUserType = connect(mapStateToProps)(CapExCategoryFormField);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(ComponentWithoutUserType);
